<script>
	import { onMount, createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
	import * as turf from '@turf/turf';
	import { save, refresh, trash, arrowRoundBack } from 'ionicons/icons/index.mjs';
	import { generateID, flatten, fetchData, addPendingReport, getCentroid } from '../utils/Data.svelte';
	import { Form, components } from "../form";
	const dispatch = createEventDispatcher();
	export let session;
	export let modal;
	export let tooltips;
	export let role;
	export let settings;
	export let isPublic;

  let files;
	let isEdit = false;
	let useLocation = false;
	let schema = null;
	let name = "";
	let ui = null;
	let value = {};
	let data = "";
	onMount(() => {
		if (modal.form) {
			if (modal.destination)
				return;
		  if (modal.form.schema)
				schema = modal.form.schema;
			if (modal.form.ui)
				ui = modal.form.ui;
			if (modal.form.name)
				name = modal.form.name;
		}
		if (modal.edit) {
			isEdit = true;
		}
		if (modal.location && modal.location.enabled && !modal.feature) {
			useLocation = true;
			if (settings.hasMaxAccuracy) {
				if (Number(modal.location.accuracy) > settings.maxAccuracy) {
					dispatch('message', {
						type: "toast",
						data: {
							message: "Location data is inaccurate."
						}
					});
				}
			}
		}
		if (modal.feature) {
			setValue(schema.properties, value);
		}
	});
	function setValue(properties, parent) {
		Object.keys(properties).map(function (key) {
			if (properties[key].description == "section") {
				if (parent)
					parent[key] = {};
				setValue(properties[key].properties, parent[key]);
			}
			else if (modal.feature.properties[key]) {
				parent[key] = modal.feature.properties[key];
			}
		})
	}
	function sendMessage(message) {
		dispatch('message', message);
	}
	async function sendMedia(data, id) {
        var path = "/layer/public/" + id + "/0";

        let [res, err]  = await fetchData("/v1/media" + path, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + session.token
            },
            body: data
        });
        console.log(err);
    }
	function uploadMedia(id) {
		if (files && files.length) {
				for (var i = 0; i < files.length; i++) {
					let data = new FormData();
					var now = new Date();
					var prefix = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + "T" + now.getHours() + "-" + now.getMinutes() + "-" + now.getSeconds() + "." + now.getMilliseconds();
						let file = files[i];
						var fullname = file.name;
						var fname = file.name.substring(0, file.name.lastIndexOf("."));
						if (fname.toLowerCase() == "image") {
								fname = prefix + "_" + i;
								var ext = file.name.substring(file.name.lastIndexOf("."));
								fullname = fname + ext;
						}
						if (file.type == "image/jpeg") {
								var reader = new FileReader();
								reader.onload = function(e) {
										var image = new Image();
										image.src = e.target.result;
										image.onload = function () {
												var ratio = this.width / this.height;
												if (ratio > 1.7) {
													fullname = fname + ".360.jpg" 
												}
												data.append("files", file, fullname);
												sendMedia(data, id);
										};
								}
								reader.readAsDataURL(file);   
						}
						else {
								data.append("files", file, fullname);
								sendMedia(data, id);
						}
				}
		}
	}
	async function saveReport(data) {
		if (role <= 1.5) {
			return;
		}
		console.log(files);
		var properties = flatten(data);
		var metadata = {};
		metadata.history = "0";
		if (modal.history)
			metadata.history = "1";
		var geometry = {};
		var form = modal.form;
		metadata.draw = "0";
		if (isEdit) {
			metadata = modal.feature.metadata;
			if (metadata.feature == "New Feature" || metadata.feature == "User Feature") {
				metadata.feature = metadata.id;
			}
			metadata.user = session.name;
			metadata.user_id = session.id;
			metadata.created = new Date().toISOString();
			geometry = modal.feature.geometry;
			if (selectedFeature.geometry.type == "Point") {
				metadata.longitude = selectedFeature.geometry.coordinates[0];
				metadata.latitude = selectedFeature.geometry.coordinates[1];
			}
			else if (selectedFeature.geometry.type == "GeometryCollection") {
				metadata.longitude = selectedFeature.geometry.geometries[0].coordinates[0];
				metadata.latitude = selectedFeature.geometry.geometries[0].coordinates[1];
			}
			else if (selectedFeature.geometry.type == "LineString") {
				var mid = Math.floor(selectedFeature.geometry.coordinates.length / 2);
				metadata.latitude = selectedFeature.geometry.coordinates[mid][1];
				metadata.longitude = selectedFeature.geometry.coordinates[mid][0];
			}
			else if (selectedFeature.geometry.type == "Polygon") {
				var centroid = getCentroid(selectedFeature.geometry.coordinates[0]);
				metadata.latitude = centroid[1];
				metadata.longitude = centroid[0];
			}
			metadata.longitude = metadata.longitude + "";
			metadata.latitude = metadata.latitude + "";
		}
		else {
			var selectedFeature = modal.feature;
			var selectedLayer = modal.layer;
			if (window.location.pathname.startsWith("/forms")) {
				geometry.type = "Point";
				geometry.coordinates = [0, 0];
				metadata.latitude = 0;
				metadata.longitude = 0;
			}
			else if (useLocation) {
				if (modal.location.status != "online") {
					dispatch('message', {
						type: "toast",
						data: {
							message: "Location data is stale."
						}
					});
					return;
				}
				if (settings.hasMaxAccuracy) {
					if (Number(modal.location.accuracy) > settings.maxAccuracy) {
						dispatch('message', {
							type: "toast",
							data: {
								message: "Location data is inaccurate."
							}
						});
						return;
					}
				}
				metadata = Object.assign({}, modal.location);
				delete metadata.status;
				delete metadata.label;
				delete metadata.enabled;
				geometry.type = "Point";
				geometry.coordinates = [metadata.longitude, metadata.latitude];
				metadata.draw = "1";
			}
			else {
				geometry = selectedFeature.geometry;
				if (selectedFeature.geometry.type == "Point") {
					metadata.longitude = selectedFeature.geometry.coordinates[0];
					metadata.latitude = selectedFeature.geometry.coordinates[1];
				}
				else if (selectedFeature.geometry.type == "GeometryCollection") {
					metadata.longitude = selectedFeature.geometry.geometries[0].coordinates[0];
					metadata.latitude = selectedFeature.geometry.geometries[0].coordinates[1];
				}
				else if (selectedFeature.geometry.type == "LineString") {
					var mid = Math.floor(selectedFeature.geometry.coordinates.length / 2);
					metadata.latitude = selectedFeature.geometry.coordinates[mid][1];
					metadata.longitude = selectedFeature.geometry.coordinates[mid][0];
				}
				else if (selectedFeature.geometry.type == "Polygon") {
					var centroid = getCentroid(selectedFeature.geometry.coordinates[0]);
					metadata.latitude = centroid[1];
					metadata.longitude = centroid[0];
				}
			}

			metadata.user = session.name;
			metadata.user_id = session.id;
			metadata.form = form.name;
			metadata.form_id = form.id;
			metadata.created = new Date().toISOString();
			metadata.id = generateID();
			if (isPublic) {
				uploadMedia(metadata.id);
			}
			metadata.version = generateID();
			if (!modal.history && selectedLayer && selectedLayer.metadata && selectedLayer.metadata["geosync:version"]) {
				var version_field = selectedLayer.metadata["geosync:version"];
				if (selectedFeature.properties[version_field])
					metadata.version = selectedFeature.properties[version_field];
			}
			metadata.action = "upsert";
			metadata.layers = form.layers;
			metadata.layer_types = form.layer_types;
			metadata.project = form.project;
			metadata.map = modal.mapName;
			metadata.map_id = modal.mapId;
			metadata.dynamic = "0";
			
			metadata.feature = "New Feature";
			if (selectedLayer) {
				if (selectedLayer.id == "__user")
					metadata.feature = "User Feature";
				else if (selectedLayer.id == "__draw" && selectedFeature.id && selectedFeature.id.includes("|")) {
					var ids = selectedFeature.id.split("|");
					var idField = "_id";
					var layer = modal.map.getLayer(ids[0]);
					if (layer) {
						selectedLayer = layer;
					}
					if (selectedLayer.id == "reportlog" || selectedLayer.id == "reportlog_line" || selectedLayer.id == "reportlog_fill") {
						idField = "history_id";
					}
					else if (selectedLayer.id != "__user" && selectedLayer.metadata && selectedLayer.metadata["geosync:id"]) {
						idField = selectedLayer.metadata["geosync:id"];
					}
					metadata.feature = selectedFeature.properties[idField];
					metadata.draw = "1";					
				}
				else if (selectedLayer.id == "__draw")
					metadata.feature = "User Feature";
				else if (selectedLayer.id == "reportlog" || selectedLayer.id == "reportlog_line" || selectedLayer.id == "reportlog_fill")
					metadata.feature = selectedFeature.properties["history_id"];
				else if (selectedLayer.id_field) {
					var idField = selectedLayer.id_field;
					metadata.feature = selectedFeature.properties[idField];
				}
				else {
					var idField = selectedLayer.metadata["geosync:id"];
					metadata.feature = selectedFeature.properties[idField];
				}
			}

			metadata.feature = metadata.feature + "";
			metadata.longitude = metadata.longitude + "";
			metadata.latitude = metadata.latitude + "";
		}
		
		if (metadata.latitude != "0" && metadata.longitude != "0") {
			if (!metadata.latitude || !metadata.longitude || Number.isNaN(Number(metadata.latitude)) || Number.isNaN(Number(metadata.longitude))) {
				dispatch('message', {
					type: "toast",
					data: {
						message: "Invalid location."
					}
				});
				return;
			}
		}

		let missing = false;
		if (modal.form.schema.required) {
			modal.form.schema.required.map(function (field) {
				if (!properties[field] || properties[field] == "not-set") {
					dispatch('message', {
						type: "toast",
						data: {
							message: "[" + field + "] is required."
						}
					});
					missing = true;
				}
			})
		}

		if (modal.form.schema.properties && properties) {
			Object.keys(modal.form.schema.properties).map(function (key) {
				if (modal.form.schema.properties[key].description && modal.form.schema.properties[key].description == "section" && modal.form.schema.properties[key].required) {
					modal.form.schema.properties[key].required.map(function (field) {
						if (!properties[field] || properties[field] == "not-set") {
							dispatch('message', {
								type: "toast",
								data: {
									message: "[" + field + "] is required."
								}
							});
							missing = true;
						}
					})
				}
			})
		}

		if (missing) {
			return;
		}

		if (modal.form.function && modal.form.function != '""') {
			let body = JSON.parse(modal.form.function);
			var compute = new Function("data", "metadata", body);
			let values = compute(properties, metadata);
			if (Array.isArray(values)) {
				if (values.length == 1) {
					properties = values[0];
				} else if (values.length >= 2) {
					properties = values[0];
					metadata = values[1];
				}
			} else {
				properties = values;
			}
		}

		var meta = {};
		if (modal.form.schema.metadata) {
			Object.keys(modal.form.schema.metadata).map(function(key) {
				var value = schema.metadata[key];
				if (metadata[value])
					meta[key] = metadata[value];
			})
		}
		
		var feature = {
			type: "Feature",
			properties: properties,
			geometry: geometry,
			metadata: meta
		}

		if (modal.form.schema.notification) {
			let options = modal.form.schema.notification;
			if (feature.properties[options.notify]) {
			  feature.notification = {
					topic: feature.properties[options.to] || "",
					title: feature.properties[options.title] || form.name,
					body:  feature.properties[options.body] || "Form submitted"
				};
			}
		}

		Object.keys(feature.properties).map(function (key) {
			if (key.startsWith("__")) {
				delete feature.properties[key];
			}
		})

		/*var center = turf.default.center(feature)
		if (center.geometry.coordinates[0] == 0 && center.geometry.coordinates[1] == 0) {
			dispatch('message', {
				type: "toast",
				data: {
					message: "Invalid location."
				}
			});
			return;
		}*/


		var report = { id: metadata.id, timestamp: new Date().getTime(), metadata: metadata, properties: Object.assign({}, properties), geometry: feature.geometry };
		dispatch('message', {
			type: "history",
			data: {
				action: isEdit ? "edit" : "add",
				report: report
			}
		});
		if (metadata.feature == "User Feature")
			dispatch('message', {
				type: "deselect",
			});
		dispatch('message', {
			type: "toast",
			data: {
				message: "Form saved."
			}
		});
		close();

		let [res, err] = await fetchData("/v1/reports", {
			method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + session.token
            },
            body: JSON.stringify({
				metadata: metadata,
				feature: feature
			})
		});
		if (err) {
			var item = {
				id: metadata.id,
				metadata: metadata,
				feature: feature
			}
			addPendingReport(item);
		} else {
			dispatch('message', {
				type: "submit"
			});
		}
	}

  function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
  }
</script>

<div class="modal modal-lg active">
		{#if !isPublic}
    	<div class="modal-overlay" on:click={close} aria-label="Close"></div>
		{/if}
    <div id="modal-container" class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">{name}</div>
                </div>
                <div class="tile-action">
					{#if modal.form.role && modal.form.role >= 2}
					<button type="submit" form="gsform" class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Save" on:click|stopPropagation={(e) => {
						e.currentTarget.blur();
					}} aria-label="Save"><i class="svg svg-light">{@html save.md}</i></button>
					<button type="reset" form="gsform" class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Reset" on:click|stopPropagation={(e) => {
						e.currentTarget.blur();
					}} aria-label="Save"><i class="svg svg-light">{@html refresh.md}</i></button>
					{/if}
					{#if modal.location && modal.location.enabled}
						<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""} {useLocation ? "active" : ""}" data-tooltip="Use Geolocation" on:click|stopPropagation={(e) => {
							e.currentTarget.blur();
							if (!modal.feature)
								return;
							useLocation = !useLocation;
						}} aria-label="Use Location"><i class="icon icon-location mt-1"></i></button>
					{/if}
					{#if modal.back}
            <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Back" on:click|stopPropagation={(e) => {
							e.currentTarget.blur();
							sendMessage({
								type: "modal",
								data: modal.back
							})
						}} aria-label="Back"><i class="svg svg-light">{@html arrowRoundBack.md}</i></button>
          {:else if modal.forms}
						<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Back" on:click|stopPropagation={(e) => {
							e.currentTarget.blur();
							sendMessage({
								type: "modal",
								data: {
									view: "forms",
									mapId: modal.mapId,
				          mapName: modal.mapName,
									forms: modal.forms,
									feature: modal.feature,
                  layer: modal.layer,
									location: modal.location
								}
							})
						}} aria-label="Back"><i class="svg svg-light">{@html arrowRoundBack.md}</i></button>
          {/if}
					<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Close" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                </div>
            </div>
        </div>
        <div class="modal-body">
            {#if schema}
                <div class="container pl-2 pr-2 mb-5" in:fade>
										{#if modal.form.schema.description}
											<h5>{modal.form.schema.description}</h5>
										{/if}
                    <Form
                        id="gsform"
                        {schema}
                        {ui}
                        {components}
                        {value}
												on:error={e => {
													dispatch('message', {
														type: "toast",
														data: {
															message: e.detail
														}
													});
                        }}
                        on:submit={e => {
													console.log(e);
                            saveReport(e.detail);
                        }}
                        on:reset={e => {
                            console.log('reset', e);
                        }}>
                    </Form>
										{#if isPublic}
										 <div class="form-group">
												<div class="col-3">
													<label class="form-label" for="__attach">Attach Files</label>
												</div>
												<div class="col-9">
													<input id="__attach" class="mt-2 pt-2" type="file" bind:files multiple>
												</div>
											</div>			 
										{/if}
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
   h5 {
		margin-top: 10px;
	 }
	.modal.modal-lg .modal-overlay {
        background: rgba(247, 248, 249, 0.75);
    }
    .modal.modal-lg .modal-container {
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        padding: 0;
    }
    .modal.modal-lg .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal.modal-lg .modal-header .btn.btn-link {
        color: white;
    }
    .modal.modal-lg .modal-body {
        padding: 0;
        height: calc(100vh - 2.1rem);
    }
	.btn.btn-link.active {
        background-color: #00884c;
    }
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
</style>